import styled from 'styled-components'
import heartIcon from './assets/solar_heart-linear.svg'

export const Container = styled.div`
  background-color: #FCF8EF;
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 62px;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  & > figure {
    aspect-ratio: 1;
    box-shadow: 0px 0px 62px 0px #00A9883D;
    max-width: 683px;
    overflow: hidden;
    position: relative;
    width: 100%;

    & > img {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 100%;
    }

    & > figcaption {
      bottom: 24px;
      color: #FFF;
      font-size: 1rem;
      font-style: italic;
      font-weight: 300;
      left: 0;
      line-height: 120%;
      position: absolute;
      right: 0;
      text-align: center;
    }
  }

  @media (max-width: 911px) {
    flex-direction: column;
    gap: 62px;
  }

  @media (max-width: 568px) {
    & > figure {
      & > figcaption {
        bottom: 12px;
      }
    }
  }
`

export const TextContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 567px;
  padding: 24px 24px 24px 0;
  width: 100%;

  & > p {
    color: #084F43;
    font-size: 1rem;
    font-weight: 400;
    line-height: 140%;
  }

  @media (max-width: 911px) {
    max-width: 683px;
    padding: 0 24px 62px;
  }

  @media (max-width: 568px) {
    align-items: initial;

    & > p {
      text-align: center;
    }
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > h1 {
    color: #084F43;
    font-size: 2rem;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -2px;
  }

  & > h2 {
    color: #084F43;
    font-size: 1rem;
    font-weight: 700;
    line-height: 120%;
  }

  & > p {
    color: #084F43;
    font-size: 1rem;
    font-weight: 400;
    line-height: 120%;
  }

  & > ul {
    list-style: none;

    li + li {
      margin-top: 16px;
    }

    & > li {
      color: #282733;
      font-size: 1rem;
      font-weight: 400;
      line-height: 140%;
      position: relative;
      padding-left: 2em;

      &::before {
        background-image: url(${heartIcon});
        background-size: contain;
        background-repeat: no-repeat;
        content: "";
        left: 0;
        height: 24px;
        position: absolute;
        width: 24px;
      }

      & > a {
        color: #568BE1;
        text-decoration: underline;
      }
    }
  }
`
